"use client"

import { useGetAPI } from "@/util/api/swr"
import { ConvertLink } from "@/util/tools"
import LoadingPage from "@/util/view/LoadingPage"
import ProductList from "@/util/view/ProductList"

const ProductsByBrand = ({ idBrand, url }: { idBrand: number, url: string }) => {
    const { data, isLoading } = useGetAPI(`/product-get?page=1&size=6&brand=[${idBrand}]`)

    if (isLoading) return <LoadingPage height="400px" />
    return (
        <div>
            <ProductList data={data} title="محصولات این برند" link={`/brand/${ConvertLink(url)}`} />
        </div>
    )
}

export default ProductsByBrand